<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->
<router-outlet></router-outlet>
<no-tickets-display
	*ngIf="(numOfFilteredTicket$ | async) === 0"
	[numberOfPlanTickets]="numOfPlanTicket$ | async"
></no-tickets-display>
<cdk-virtual-scroll-viewport
	*ngIf="ticketService.filteredTicketList$ | async"
	itemSize="{{ ticketListHeight }}"
	minBufferPx="{{ ticketListHeight * ticketsPerMinBufferHeight }}"
	maxBufferPx="{{ ticketListHeight * ticketsPerMaxBufferHeight }}"
	class="full-height"
	[ngClass]="!(ticketService.onTicketDetailsView$ | async) ? '' : 'hide-list-view'"
>
	<div *cdkVirtualFor="let ticket of ticketService.filteredTicketList$ | async">
		<ticket-list-item
			class="ticket-list-item"
			[selected]="ticket.selected"
			[cycleSelected]="ticket.cycleSelected"
			[liveDurationDays]="ticket.view.liveDurationDays"
			[liveCrewSize]="ticket.view.liveCrewSize"
			[ticketType]="ticket.view.type"
			[liveRole]="ticket.view.liveRole"
			[activityName]="ticket.view.activityName"
			[actualFinish]="ticket.view.actualFinish"
			[actualStart]="ticket.view.actualStart"
			[locationName]="ticket.view.location?.view?.name"
			[selectedType]="ticket.view.selectedType"
			[livePromisePeriodStack]="ticket.view.livePromisePeriodStack"
			[liveStart]="ticket.view.liveStart"
			[liveFinish]="ticket.view.liveFinish"
			[routerLink]="['./', ticket.$id]"
		>
		</ticket-list-item>
	</div>
</cdk-virtual-scroll-viewport>
